<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useThemeStore } from "../../stores/theme";
import ThemeSelect from "../helpers/ThemeSelect.vue";

const { theme } = storeToRefs(useThemeStore());
</script>

<template>
	<div class="flex flex-col gap-2 pb-2">
		<h2>{{ $t("profile.theme") }}</h2>
		<ThemeSelect v-model:theme="theme" class="pl-2" />
	</div>
</template>
